import { configureStore } from "@reduxjs/toolkit";

import { listenerMiddleware } from "./listenerMiddleware";
import buildBroadcastMiddleware from "./buildBroadcastMiddleware";
import buildUrlMiddleware from "./buildUrlMiddleware";

import deckReducer from "../features/deck/deckSlice";
import helpReducer from "../features/help/helpSlice";
import transcludeReducer from "../features/transclude/transcludeSlice";
import routeReducer from "../features/route/routeSlice";
import windowReducer from "../features/window/windowSlice";
import skippedReducer from "../features/skipped/skippedSlice";

interface buildStoreProps {
  channel: BroadcastChannel;
  window: Window;
}

export const reducer = {
  deck: deckReducer,
  help: helpReducer,
  transclude: transcludeReducer,
  route: routeReducer,
  skipped: skippedReducer,
  window: windowReducer,
};

export const buildStore = ({ channel, window }: buildStoreProps) => {
  buildBroadcastMiddleware(channel);
  buildUrlMiddleware(window);

  return configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(listenerMiddleware.middleware),
  });
};

export type Store = ReturnType<typeof buildStore>;

export type RootState = ReturnType<Store["getState"]>;
export type AppDispatch = Store["dispatch"];
